/**
 * @flow
 */

import {
  SHOW_FLASH,
  CLEAR_FLASH,
  SHOW_BANNER,
  CLEAR_BANNER,
  SET_HOST_ID,
  SET_REFUND_MESSSAGE,
  SET_TICKET_ID,
  SET_GUEST_HOST_FIELDS,
  SET_BUYER_HOST_FIELDS,
  SET_COST_ITEM,
  SET_REFUND_PAGE_LINK,
  UPDATE_GUEST_HOST_FIELDS,
  UPDATE_BUYER_HOST_FIELDS,
  UPDATE_INPUT_FIELD,
  CANCEL_ORDER,
  CANCEL_ORDER_SUCCESS,
  CANCEL_ORDER_ERROR,
  TRANSFER_TICKET,
  TRANSFER_TICKET_SUCCESS,
  TRANSFER_TICKET_ERROR,
  TRANSFER_TICKET_RESET,
  CANCEL_TICKET_TRANSFER_SUCCESS,
  UPDATE_COST_ITEM_HOST_FIELDS,
  UPDATE_COST_ITEM_HOST_FIELDS_SUCCESS,
  UPDATE_COST_ITEM_HOST_FIELDS_ERROR,
  UPDATE_TICKET_HOST_FIELDS,
  UPDATE_TICKET_HOST_FIELDS_SUCCESS,
  UPDATE_TICKET_HOST_FIELDS_ERROR,
  SEND_HOST_MESSAGE,
  SEND_HOST_MESSAGE_SUCCESS,
  SEND_HOST_MESSAGE_ERROR,
  ON_MY_TICKETS_MOUNT,
  ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS,
  ON_MY_TICKETS_PAST_MOUNT_SUCCESS,
  ON_MY_PASSES_MOUNT,
  ON_MY_PASSES_MOUNT_SUCCESS,
  PAGINATION_SET_PAGE,
  ON_MY_TICKETS_CURRENT_MOUNT_ERROR,
  ON_MY_TICKETS_PAST_MOUNT_ERROR
} from '../actions';

const initialState = {
  loadingPast: false,
  loadingCurrent: false,
  loadingPasses: false,
  guestHostFields: null,
  buyerHostFields: null,
  selectedHostId: null,
  refundMessage: '',
  refundPageLink: null,
  selectedTicketId: null,
  selectedCostItem: null,
  inputFields: {
    firstName: '',
    lastName: '',
    email: ''
  },
  flash: [],
  banner: {
    message: null,
    level: null,
    values: {}
  },
  requestPending: false,
  requestSuccess: false
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    case ON_MY_PASSES_MOUNT:
      return Object.assign({}, initialState, {
        loadingPasses: true
      });

    case ON_MY_PASSES_MOUNT_SUCCESS:
      return Object.assign({}, state, { loadingPasses: false });

    case ON_MY_TICKETS_MOUNT:
      return Object.assign({}, state, { loadingCurrent: true, loadingPast: true });

    case ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS:
      return Object.assign({}, state, { loadingCurrent: false });

    case ON_MY_TICKETS_PAST_MOUNT_SUCCESS:
      return Object.assign({}, state, { loadingPast: false });

    case ON_MY_TICKETS_CURRENT_MOUNT_ERROR:
      return Object.assign({}, state, { loadingCurrent: false });

    case ON_MY_TICKETS_PAST_MOUNT_ERROR:
      return Object.assign({}, state, { loadingPast: false });

    case PAGINATION_SET_PAGE:
      return Object.assign({}, state, {
        selectedCostItem: null,
        selectedTicketId: null,
        selectedHostId: null
      });

    case SHOW_FLASH:
      return Object.assign({}, state, {
        flash: state.flash.concat({
          message: action.message,
          level: action.level
        })
      });

    case CLEAR_FLASH:
      return Object.assign({}, state, {
        flash: state.flash.slice(1, state.flash.length)
      });

    case SHOW_BANNER:
      return Object.assign({}, state, {
        banner: {
          message: action.payload.message,
          level: action.payload.level,
          values: action.payload.values,
        },
      });

    case CLEAR_BANNER:
      return Object.assign({}, state, {
        banner: {
          message: null,
          level: null,
          values: {}
        }
      });

    case SET_HOST_ID:
      return Object.assign({}, state, { selectedHostId: action.payload.hostId });

    case SET_REFUND_MESSSAGE:
      return Object.assign({}, state, { refundMessage: action.payload.message });

    case SET_TICKET_ID:
      return Object.assign({}, state, { selectedTicketId: action.payload.ticketId });

    case SET_COST_ITEM:
      return Object.assign({}, state, { selectedCostItem: action.payload.costItemId });

    case SET_REFUND_PAGE_LINK:
      return Object.assign({}, state, { refundPageLink: action.payload.link });

    case UPDATE_INPUT_FIELD:
      const field = state.inputFields;

      if (action.payload.input === 'firstName') {
        field.firstName = action.payload.value;

        return Object.assign({}, state, { inputFields: field });
      }
      else if (action.payload.input === 'lastName') {
        field.lastName = action.payload.value;

        return Object.assign({}, state, { inputFields: field });
      }
      else if (action.payload.input === 'email') {
        field.email = action.payload.value;

        return Object.assign({}, state, { inputFields: field });
      }

    case SEND_HOST_MESSAGE:
      return Object.assign({}, state, { requestPending: true  });

    case SEND_HOST_MESSAGE_SUCCESS:
      return Object.assign({}, state, { refundMessage: '', requestPending: false });

    case SEND_HOST_MESSAGE_ERROR:
      return Object.assign({}, state, { requestPending: false });

    case TRANSFER_TICKET:
      return Object.assign({}, state, {
        requestSuccess: false,
        requestPending: true
      });

    case CANCEL_TICKET_TRANSFER_SUCCESS:
      return Object.assign({}, state, {
        requestSuccess: false,
        requestPending: false
      });

    case TRANSFER_TICKET_SUCCESS:
      return Object.assign({}, state, {
        requestSuccess: true,
        requestPending: false
      });

    case TRANSFER_TICKET_RESET:
      return Object.assign({}, state, {
        selectedCostItem: null,
        selectedTicketId: null,
        selectedHostId: null,
        requestSuccess: false,
        requestPending: false,
        inputFields: {
          firstName: '',
          lastName: '',
          email: ''
        }
      });

    case TRANSFER_TICKET_ERROR:
      return Object.assign({}, state, {
        requestSuccess: false,
        requestPending: false,
        selectedCostItem: null,
        selectedTicketId: null,
        selectedHostId: null,
        inputFields: {
          firstName: '',
          lastName: '',
          email: ''
        }
      });

    case CANCEL_ORDER:
      return Object.assign({}, state, {
        requestPending: true
      });

    case CANCEL_ORDER_SUCCESS:
      return Object.assign({}, state, {
        requestPending: false,
        selectedCostItem: null,
        selectedTicketId: null,
        selectedHostId: null
      });

    case CANCEL_ORDER_ERROR:
      return Object.assign({}, state, {
        requestPending: false
      });

    case SET_GUEST_HOST_FIELDS:
      // Remove Ticket Level Host Fields
      const removeTicketLevelFields = action.payload.hostFields.filter(hf => hf.context === 'CostItem');
      return Object.assign({}, state, { guestHostFields: removeTicketLevelFields });

    case SET_BUYER_HOST_FIELDS:
      // Remove CostItem Level Host Fields
      const removeCostItemFields = action.payload.hostFields.filter(hf => hf.context === 'Ticket');
      return Object.assign({}, state, { buyerHostFields: removeCostItemFields });

    case UPDATE_GUEST_HOST_FIELDS:
      const updatedHostFields = state.guestHostFields.map(hostField => {
        if (hostField.id === action.payload.id) {
          hostField.value = action.payload.value;
        }
        return hostField;
      });

      return Object.assign({}, state, {
        guestHostFields: updatedHostFields
      });

    case UPDATE_BUYER_HOST_FIELDS:
      const updatedBuyerFields = state.buyerHostFields.map(hostField => {
        if (hostField.id === action.payload.id) {
          hostField.value = action.payload.value;
        }
        return hostField;
      });

      return Object.assign({}, state, {
        buyerHostFields: updatedBuyerFields
      });


    case UPDATE_COST_ITEM_HOST_FIELDS:
      return Object.assign({}, state, {
        requestPending: true
      });

    case UPDATE_COST_ITEM_HOST_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        selectedCostItem: null,
        selectedTicketId: null,
        selectedHostId: null,
        requestPending: false,
        inputFields: {
          firstName: '',
          lastName: '',
          email: ''
        }
      });

    case UPDATE_COST_ITEM_HOST_FIELDS_ERROR:
      return Object.assign({}, state, {
        requestPending: false
      });

    case UPDATE_TICKET_HOST_FIELDS:
      return Object.assign({}, state, {
        requestPending: true
      });

    case UPDATE_TICKET_HOST_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        requestPending: false,
        selectedCostItem: null,
        selectedTicketId: null,
        selectedHostId: null,
        inputFields: {
          firstName: '',
          lastName: '',
          email: ''
        }
      });

    case UPDATE_TICKET_HOST_FIELDS_ERROR:
      return Object.assign({}, state, {
        requestPending: false
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/my-tickets/reducers/ui.js